export enum PusherEvent {
  NOTIFICATION = 'notification', // new notification
}
